import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import { catchError, concatMap, endWith, flatMap, map, mergeAll, mergeMap, startWith, switchMap, take } from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// API lấy danh sách loại phương tiện
const getTypeTransportation = (action$, state$) => {
   return action$.pipe(
      ofType(CONSTANTS.ACTION.TYPE_TRANSPORTATION.GET_TYPE_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const typeTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TYPE_TRANSPORTATION.GET_ALL)
            let arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TYPE_TRANSPORTATION.SET_TYPE_TRANSPORTATION, typeTransportation.data.data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => {
                  return concat(from(res))
               }),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
}
// API lấy danh sách hình thức kinh doanh vận tải 
const getFormTransportation = (action$, state$) => {
   return action$.pipe(
      ofType(CONSTANTS.ACTION.FORM_TRANSPORTATION.GET_FORM_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const formTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.FORM_TRANSPORTATION.GET_ALL)
            const arrayAction = []
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.FORM_TRANSPORTATION.SET_FORM_TRANSPORTANTION, formTransportation.data.data))
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => {
                  return concat(from(res))
               }),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
}

// API lấy danh sách loại nhiên liệu
const getTypeFuelTransportation = (action$, state$) => {
   return action$.pipe(
      ofType(CONSTANTS.ACTION.TYPE_FUEL_TRANSPORTATION.GET_TYPE_FUEL_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const typeFuelTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.TYPE_FUEL_TRANSPORTATION.GET_ALL)
            let arrayAction = []
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.TYPE_FUEL_TRANSPORTATION.SET_TYPE_FUEL_TRANSPORTANTION, typeFuelTransportation.data.data)
            )
            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => {
                  return concat(from(res))
               }),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
}

/**
 * @description: **Epic thêm mới đăng kiểm**
 * @param  param:  param type
 * @return void  and write logs
 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:08:35 2019-10-04
 */
const reloadRegistraionPaper = (action$, state$) => {
   return action$.pipe(
      ofType(CONSTANTS.ACTION.REGISTRATION_PAPER.SET_REGISTRATION_PAPER),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            // Lấy danh sách trung tâm đăng kiểm
            const getRegistrationCenterProvider = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.REGISTRATION_CENTER_PROVIDER.GET_ALL)

            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(
                  CONSTANTS.ACTION.REGISTRATION_CENTER_PROVIDER.SET_REGISTRATION_CENTER_PROVIDER,
                  getRegistrationCenterProvider.data.data
               )
            )

            // Lấy danh sách trung tâm bảo hiểm
            const getInsuranceCenterProvider = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.INSURANCE_CENTER_PROVIDER.GET_ALL)

            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.INSURANCE_CENTER_PROVIDER.SET_INSURANCE_CENTER_PROVIDER, getInsuranceCenterProvider.data.data)
            )

            // Lấy danh sách trung tâm cung cấp phù hiệu
            const getCarBadgesCenterProvider = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.CAR_BADGES_CENTER_PROVIDER.GET_ALL)

            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(
                  CONSTANTS.ACTION.CAR_BADGES_CENTER_PROVIDER.SET_CAR_BADGES_CENTER_PROVIDER,
                  getCarBadgesCenterProvider.data.data
               )
            )
            // Lấy danh sách loại phù hiệu
            const getCarBadgesType = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.CAR_BADGES_TYPE.GET_ALL)

            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.CAR_BADGES_TYPE.SET_CAR_BADGES_TYPE, getCarBadgesType.data.data))
            // Lấy danh sách trung tâm đăng ký xe registration_card_CENTER_PROVIDER
            const getRegistrationCardCenterProvider = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.REGISTRATION_CARD_CENTER_PROVIDER.GET_ALL)
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(
                  CONSTANTS.ACTION.REGISTRATION_CARD_CENTER_PROVIDER.SET_REGISTRATION_CARD_CENTER_PROVIDER,
                  getRegistrationCardCenterProvider.data.data
               )
            )
            // Lấy danh sách hãng xe factoryTransportation
            const factoryTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.FACTORY_TRANSPORTATION.GET_ALL)
            arrayAction.push(
               CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.FACTORY_TRANSPORTATION.SET_FACTORY_TRANSPORTATION, factoryTransportation.data.data)
            )

            // Lấy danh sách thành viên
            const getMember = await CONSTANTS.FUNCTION.AXIOS.GET(CONSTANTS.URL.MEMBER.GET_ALL)
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.MEMBER.SET_MEMBER, getMember.data.data))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
}

// API lấy báo cáo chi phí của phương tiện
const reportFeeTransportationEpic = (action$, state$) => {
   return action$.pipe(
      ofType(CONSTANTS.ACTION.SYSTEM.REPORT_FEE_TRANSPORTATION),
      mergeMap((action) => {
         const api = async () => {
            const arrayAction = []
            // Lấy danh sách thành viên
            const reportFeeTransportation = await CONSTANTS.FUNCTION.AXIOS.GET(
               `${CONSTANTS.URL.REPORT.REPORT_FEE_TRANSPORTATION}?option_vehicle=${action.payload.filterPT}&option_time=${action.payload.time}&option_fee=${action.payload.type}&option_sort=${action.payload.sort}`
            )
            arrayAction.push(CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.UPDATE_REPORT_FEE_TRANSPORTATION, reportFeeTransportation.data.data))

            return arrayAction
         }
         return concat(
            from(api()).pipe(
               mergeMap((res) => concat(from(res))),
               catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
            )
         )
      })
   )
}

export default {
   getTypeTransportation,
   getFormTransportation,
   getTypeFuelTransportation,
   reloadRegistraionPaper,
   reportFeeTransportationEpic
}
